module.exports = __webpack_public_path__ + "static/media/eye.4994431f.svg";